import React from 'react';
import Authentication from '../Authenticate/index';
import { Route, Switch } from "react-router-dom";
import { privateRoutesPath } from './index'
import PrivateLayout from '../Components/Layout/PrivateLayout';
import Leads from '../Pages/Lead';
import CustomerPage from '../Pages/Customer/index';
import ConfigurationPage from '../Pages/Configuration/index';
import MerchantPage from '../Pages/Vendor/index';
import ProductPage from '../Pages/Product/ProductVendorTab';
import CreateLead from '../Pages/Lead/CreateLead';
import EditLead from '../Pages/Lead/EditLead';
import CreateProduct from '../Pages/Product/CreateProduct';
import EditProduct from '../Pages/Product/EditProduct';
import CreateCustomer from '../Pages/Customer/CreateCustomer';
import InvoicePage from '../Pages/Invoice';
import OrderPage from '../Pages/SalesOrder/index'
import CreateEditSalesOrder from '../Pages/SalesOrder/CreateEditSalesOrder';
import CreateEditInvoice from '../Pages/Invoice/CreateEditInvoice';
import GlobalSearchPage from '../Pages/Globalsearch';
import BiztantuCampaign from '../Pages/Campaign';
import RequestCampaign from '../Pages/Campaign/RequestCampaign';
import BiztantuCreateEditTemplate from '../Pages/Template/CreateEditTemplate';
import BiztantuEmailTemplate from '../Pages/Template';
import ExternalCampaignLayout from '../Pages/Campaign/ExternalCampaignlayout';
import AuditLogs from '../Pages/Configuration/Audit';
import CreateInvoice from '../Pages/Invoice/CreateInvoice';
import CreateVendor from '../Pages/Vendor/CreateVendor';
import EditVendor from '../Pages/Vendor/EditVendor';
import BiztantuDashboard from '../Pages/Dashboard/BiztantuDashboard';
import ReportPage from '../Pages/Reports';
import ProfileHomePage from '../Pages/Profile';
import TaskPage from '../Pages/Configuration/Tasks';
import CreateTasks from '../Pages/Configuration/Tasks/CreateTasks';
import EditTask from '../Pages/Configuration/Tasks/EditTask';
import WorkflowPage from '../Pages/Workflow';
import CreateEditWorkflow from '../Pages/Workflow/CreateEditWorkflow';
import CommonBulkUpload from '../Components/CommonBulkUpload';
import RequirePermission from './RequirePermission';
import UnauthorizedPage from '../Pages/Unauthorized';
import NotFoundPage from '../Pages/NotFound';

const PrivateRoute = (props) => {

    return (
        <PrivateLayout location={props.location}>
            <Authentication>
                <Switch>
                    {/* Unauthorized page — accessible to all authenticated users */}
                    <Route exact path={privateRoutesPath.UNAUTHORIZED} component={UnauthorizedPage} />
                    <Route exact path={privateRoutesPath.PAGE_NOT_FOUND} component={NotFoundPage} />

                    {/* Protected routes — each wrapped in RequirePermission for RBAC enforcement */}
                    <RequirePermission exact path={privateRoutesPath.DASHBOARD} component={BiztantuDashboard} />
                    <RequirePermission exact path={privateRoutesPath.INVOICE} component={InvoicePage} />
                    <RequirePermission exact path={`${privateRoutesPath.EDIT_INVOICE}/:id`} component={CreateEditInvoice} />
                    <RequirePermission exact path={privateRoutesPath.CREATE_INVOICE} component={CreateInvoice} />
                    <RequirePermission exact path={privateRoutesPath.LEADS} component={Leads} />
                    <RequirePermission exact path={privateRoutesPath.CUSTOMER} component={CustomerPage} />
                    <RequirePermission exact path={privateRoutesPath.TASKS} component={TaskPage} />
                    <RequirePermission exact path={privateRoutesPath.TASKS_CREATE} component={CreateTasks} />
                    <RequirePermission exact path={`${privateRoutesPath.EDIT_TASK}/:taskId`} component={EditTask} />
                    <RequirePermission exact path={privateRoutesPath.MERCHANT} component={MerchantPage} />
                    <RequirePermission exact path={privateRoutesPath.PRODUCT} component={ProductPage} />
                    <RequirePermission exact path={privateRoutesPath.CONFIGURATION} component={ConfigurationPage} />
                    <RequirePermission exact path={privateRoutesPath.REPORTS} component={ReportPage} />
                    <RequirePermission exact path={privateRoutesPath.CREATE_LEAD} component={CreateLead} />
                    <RequirePermission exact path={privateRoutesPath.COMMON_BULK_UPLOAD} component={CommonBulkUpload} />
                    <RequirePermission exact path={`${privateRoutesPath.EDIT_LEAD}/:id`} component={EditLead} />
                    <RequirePermission exact path={`${privateRoutesPath.CREATE_PRODUCT}`} component={CreateProduct} />
                    <RequirePermission exact path={`${privateRoutesPath.EDIT_PRODUCT}/:id`} component={EditProduct} />
                    <RequirePermission exact path={`${privateRoutesPath.CREATE_MERCHANT}`} component={CreateVendor} />
                    <RequirePermission exact path={`${privateRoutesPath.EDIT_MERCHANT}/:id`} component={EditVendor} />
                    <RequirePermission exact path={`${privateRoutesPath.CREATE_CUSTOMER}`} component={CreateCustomer} />
                    <RequirePermission exact path={`${privateRoutesPath.EDIT_CUSTOMER}/:id`} component={CreateCustomer} />
                    <RequirePermission exact path={privateRoutesPath.ORDER} component={OrderPage} />
                    <RequirePermission exact path={`${privateRoutesPath.VIEW_ORDER}/:id`} component={CreateEditSalesOrder} />
                    <RequirePermission exact path={privateRoutesPath.GLOBAL_SEARCH} component={GlobalSearchPage} />
                    <RequirePermission exact path={`${privateRoutesPath.CREATE_ORDER}`} component={CreateEditSalesOrder} />
                    <RequirePermission exact path={`${privateRoutesPath.BIZTANTU_CAMPAIGN}`} component={BiztantuCampaign} />
                    <RequirePermission exact path={`${privateRoutesPath.REQUEST_CAMPAIGN}`} component={RequestCampaign} />
                    <RequirePermission exact path={`${privateRoutesPath.BIZTANTU_AUDIT}`} component={AuditLogs} />

                    <RequirePermission exact path={`${privateRoutesPath.BIZTANTU_TEMPLATE}`} component={BiztantuEmailTemplate} />
                    <RequirePermission exact path={`${privateRoutesPath.CREATE_TEMPLATE}`} component={BiztantuCreateEditTemplate} />
                    <RequirePermission exact path={`${privateRoutesPath.EDIT_TEMPLATE}/:id`} component={BiztantuCreateEditTemplate} />
                    <RequirePermission exact path={`${privateRoutesPath.SEND_EXTERNAL_EMAIL}`} component={ExternalCampaignLayout} />
                    <RequirePermission exact path={`${privateRoutesPath?.PROFILE}`} component={ProfileHomePage} />
                    <RequirePermission exact path={`${privateRoutesPath.WORKFLOW}`} component={WorkflowPage} />
                    <RequirePermission exact path={`${privateRoutesPath.CREATE_WORKFLOW}`} component={CreateEditWorkflow} />
                    <RequirePermission exact path={`${privateRoutesPath.CREATE_WORKFLOW}/:id`} component={CreateEditWorkflow} />

                    {/* Wildcard / Fallback route: Renders NotFoundPage for any unmatched /biztantu/* URL */}
                    <Route component={NotFoundPage} />
                </Switch>
            </Authentication>
        </PrivateLayout>
    )
}

export default PrivateRoute;